import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import "./sections/SaasSections.css";
import "./Product.css";
import techAnimation from "../assests/TechAnimation.json";
import ProductCards from "./sections/ProductCards";

export default function Product() {

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="productLayout">
      <div className="productHero">
        <div className="topCurve"></div>
        <div className="productCardFull">
          <div className={`logo_curve1 ${isScrolled ? "logo_curve1_scrolled" : ""}`}></div>
          <div className={`logo_curve2 ${isScrolled ? "logo_curve2_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve1 ${isScrolled ? "menu-icon-curve1_scrolled" : ""}`}></div>
          <div className={`menu-icon-curve2 ${isScrolled ? "menu-icon-curve2_scrolled" : ""}`}></div>
          <div className="logo_curve1_Mo"></div>
          <div className="logo_curve2_Mo"></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>
          <div className="productContent">
            <h1 className="productTitle">Products</h1>
            <p>
              Explore Quinterra&apos;s AI-powered SaaS product ecosystem - HRMS, school ERP,
              lead generation, and land intelligence platforms built for scale.
            </p>
          </div>
          <div className="productAnimation">
            <Lottie animationData={techAnimation} loop={true} speed={0.1} />
          </div>
        </div>
      </div>

      <section className="saas-section products-page-section">
        <h2 className="saas-section__title">OUR PRODUCTS</h2>
        <div className="saas-section__header">
          <p className="saas-section__intro">
            Quinterra builds and operates cloud-native AI SaaS products across HRTech, EdTech,
            sales intelligence, and land analytics. Each platform is designed to automate workflows,
            reduce manual effort, and scale with your business.
          </p>
        </div>
        <div className="saas-section__body">
          <ProductCards detailed />
        </div>
      </section>
    </div>
  );
}
